export default {"src":"/_next/static/media/import.71655101.svg","height":30,"width":30,"blurWidth":0,"blurHeight":0};